module.exports = __webpack_public_path__ + "static/media/8.eb1f7ad9.jpg";